import styled from 'styled-components';

export const $MenuButtonContainer = styled('div')`
  position: relative;
`;
